exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".payment h6{margin-bottom:0;margin-top:0}.payment .el-row{margin-bottom:5px}", ""]);

// exports
